<mat-expansion-panel class="audit-details__panel" *ngIf="audit">
  <mat-expansion-panel-header>
    <mat-panel-title>
      Audit Report Details
    </mat-panel-title>
  </mat-expansion-panel-header>

  <div class="audit-details__panel__header">
    <button mat-raised-button class="edit-button" (click)="editAudit()" *ngIf="canUpdate">Edit</button>
  </div>

  <div class="audit-details__panel__values">
    <div class="audit-details__panel__values--id iaud-value-container">
      <label for="audit-id">Audit id:</label>
      <p id="audit-id">{{ audit.auditId }}</p>
    </div>

    <div class="audit-details__panel__values--code iaud-value-container">
      <label for="audit-code">Audit code:</label>
      <p id="audit-code">{{ audit.auditCode }}</p>
    </div>

    <div class="audit-details__panel__values--title iaud-value-container">
      <label for="audit-title">Audit title:</label>
      <p id="audit-title">{{ audit.auditTitle }}</p>
    </div>

    <div class="audit-details__panel__values--type iaud-value-container">
      <label for="audit-type">Audit type:</label>
      <p id="audit-type">{{ audit.auditType }}</p>
    </div>

    <div class="audit-details__panel__values--owner-group iaud-value-container">
      <label for="audit-owner-group">Audit owner group:</label>
      <p id="audit-owner-group">{{ audit.auditOwnerGroup }}</p>
    </div>

    <div class="audit-details__panel__values--sme iaud-value-container">
      <label for="audit-sme">Subject matter expert (sme):</label>
      <p id="audit-sme" *ngFor="let approver of audit.smeApprovers">
        {{ approver.fullName }}
      </p>
    </div>

    <div class="audit-details__panel__values--external iaud-value-container">
      <label for="audit-external-partner">External business partner:</label>
      <p id="audit-external-partner">{{ audit.externalPartner }}</p>
    </div>

    <div class="audit-details__panel__values--due-date iaud-value-container">
      <label for="audit-due-date">Audit due date</label>
      <p id="audit-due-date">{{ audit.dueDate | date:dateFormat }}</p>
    </div>

    <div class="audit-details__panel__values--status iaud-value-container">
      <label for="audit-status">Audit status:</label>
      <p id="audit-status">{{ audit.status }}</p>
    </div>

    <div class="audit-details__panel__values--description iaud-value-container description">
      <label for="audit-description">Audit description:</label>
      <p id="audit-description">{{ audit.auditDescription }}</p>
    </div>
  </div>
</mat-expansion-panel>